import Login from "../../views/auth/Login";
import UserType from "../../views/auth/UserType";
import ForgotPassword from "../../views/auth/ForgotPassword";
import ChangePassword from "../../views/auth/ChangePassword";
import Google2FA from "../../views/auth/Google2FA";
import VerifyEmail from "../../views/auth/VerifyEmail";

const routes = [
  {
    component: Login,
    exact: true,
    path: "/admin/login",
  },
  {
    component: Login,
    exact: true,
    path: "/admin/",
  },
  {
    component: Google2FA,
    exact: true,
    path: "/verify-pin/:challenge_token"
  },
  {
    component: UserType,
    exact: true,
    path: "/admin/user-type",
  },
  {
    component: ForgotPassword,
    exact: true,
    path: "/forgot-password",
  },
  {
    component: ChangePassword,
    exact: true,
    path: "/change-password/:token",
  },
  {
    component: VerifyEmail,
    exact: true,
    path: "/verify-email/:token",
  },
];

export default routes;
